import { render, staticRenderFns } from "./NewDocument.vue?vue&type=template&id=b86f46c4"
import script from "./NewDocument.vue?vue&type=script&lang=js"
export * from "./NewDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports